<div class="candidateProfile">
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="d-sm-flex align-items-center justify-content-between mb-2 maintitle pr-0">
                    <h1>Change Password</h1>
                    <div class="ml-auto">
                        <div class="ml-auto d-flex title-action" matTooltip="Back">
                            <a class="btn btn-csv bgwhite" onClick="javascript:history.go(-1)"> <i
                                    class="fa fa-arrow-left"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form [formGroup]="changePaswordForm" (ngSubmit)="onSubmit()">
            <div class="form-content">
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="oldPassword" class="form-label">Old Password<span class="req">*</span></label>
                            <input [type]="showPasswordO ? 'text' : 'password'" formControlName="oldPassword"
                                (keydown.space)="$event.preventDefault()" class="form-control"
                                [ngClass]="{ 'is-invalid': submited && changePaswordForm.get('oldPassword')?.errors }"
                                minlength="8" maxlength="25" />
                            <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibilityO()">
                                {{showPasswordO?'visibility':'visibility_off'}}
                            </mat-icon>
                            <div *ngIf="submited && changePaswordForm.get('oldPassword')?.errors"
                                class="invalid-feedback" (click)="togglePasswordVisibilityO()">
                                <div *ngIf="changePaswordForm.get('oldPassword')?.errors?.['required']">Old password is
                                    required</div>
                                <div *ngIf="changePaswordForm.get('oldPassword')?.errors?.['pattern']">Old password must
                                    be at least 8 characters and include one lowercase, uppercase, digit, and special
                                    character.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="newPassword" class="form-label">New Password<span class="req">*</span></label>
                            <input [type]="showPasswordN ? 'text' : 'password'" formControlName="newPassword"
                                (keydown.space)="$event.preventDefault()" class="form-control"
                                [ngClass]="{ 'is-invalid': submited && changePaswordForm.get('newPassword')?.errors }"
                                minlength="8" maxlength="25" />
                            <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibilityN()">
                                {{showPasswordN?'visibility':'visibility_off'}}
                            </mat-icon>
                            <div *ngIf="submited && changePaswordForm.get('newPassword')?.errors"
                                class="invalid-feedback" (click)="togglePasswordVisibilityN()">
                                <div *ngIf="changePaswordForm.get('newPassword')?.errors?.['required']">New password is
                                    required</div>
                                <div *ngIf="changePaswordForm.get('newPassword')?.errors?.['pattern']">Password must be
                                    at least 8 characters and include one lowercase, uppercase, digit, and special
                                    character.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label for="confirmPassword" class="form-label">Confirm Password<span
                                    class="req">*</span></label>
                            <input [type]="showPasswordC ? 'text' : 'password'" formControlName="confirmPassword"
                                (keydown.space)="$event.preventDefault()" class="form-control"
                                [ngClass]="{ 'is-invalid': submited && changePaswordForm.get('confirmPassword')?.errors }"
                                minlength="8" maxlength="25" />
                            <mat-icon matSuffix class="eyeIcon" (click)="togglePasswordVisibilityC()">
                                {{showPasswordC?'visibility':'visibility_off'}}
                            </mat-icon>
                            <div *ngIf="submited && changePaswordForm.get('confirmPassword')?.errors"
                                class="invalid-feedback" (click)="togglePasswordVisibilityC()">
                                <div *ngIf="changePaswordForm.get('confirmPassword')?.errors?.['required']">Confirm
                                    password is required</div>
                                <div *ngIf="changePaswordForm.get('confirmPassword')?.errors?.['pattern']">Password must
                                    be at least 8 characters and include one lowercase, uppercase, digit, and special
                                    character.</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-danger" *ngIf="notMatch">
                    <p>Passwords do not match. Please re-enter the password.</p>
                </div>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">Submit</button>
                <button type="reset" class="btn btn-secondary" (click)="clearData()">Reset</button>
            </div>
        </form>
    </div>